import { createFileRoute } from "@tanstack/react-router";
import Navbar from "@/components/Navbar";
import ScrollFrameHero from "@/components/ScrollFrameHero";
import FormSection from "@/components/FormSection";

import FeaturesGridSection from "@/components/FeaturesGridSection";
import FaqSection from "@/components/FaqSection";
import AgenteIaSection from "@/components/AgenteIaSection";
import AutomacaoSection from "@/components/AutomacaoSection";
import FooterSection from "@/components/FooterSection";

import GlowTransition from "@/components/GlowTransition";

export const Route = createFileRoute("/")({
  head: () => ({
    links: [
      { rel: "preload", as: "image", href: "/hero-poster.jpg", fetchpriority: "high", media: "(min-width: 768px)" },
      { rel: "preload", as: "image", href: "/hero-poster-mobile.jpg", fetchpriority: "high", media: "(max-width: 767px)" },
      { rel: "preload", as: "video", href: "/hero-bg.mp4", type: "video/mp4", fetchpriority: "high", media: "(min-width: 768px)" },
      { rel: "preload", as: "video", href: "/hero-bg-mobile.mp4", type: "video/mp4", fetchpriority: "high", media: "(max-width: 767px)" },
      { rel: "preload", as: "video", href: "/automacao.webm", type: "video/webm" },
      { rel: "preload", as: "video", href: "/agente-ia.webm", type: "video/webm" },

      { rel: "preload", as: "image", href: "https://i.postimg.cc/wT9psmpd/branco-porsche-(1).webp", fetchpriority: "high" },
      { rel: "preconnect", href: "https://i.postimg.cc" },
      { rel: "preconnect", href: "https://i.pravatar.cc" },
      { rel: "preload", as: "image", href: "https://i.pravatar.cc/40?img=12" },
      { rel: "preload", as: "image", href: "https://i.pravatar.cc/40?img=32" },
      { rel: "preload", as: "image", href: "https://i.pravatar.cc/40?img=47" },
      { rel: "preload", as: "image", href: "https://i.pravatar.cc/40?img=68" },
    ],
  }),

  component: Index,
});

function Index() {
  return (
    <main className="min-h-screen bg-background text-foreground">
      <Navbar />
      <ScrollFrameHero />
      <div className="noise-wrapper">
        <FormSection />
        <GlowTransition />
        <FeaturesGridSection />
        <AgenteIaSection />
        <AutomacaoSection />
        <FaqSection />
        <div className="noise-overlay noise-overlay--70" aria-hidden="true" />
        <div className="dot-overlay" aria-hidden="true" />
      </div>
      <FooterSection />
    </main>
  );
}
